export { default } from './CicEmptyMessage';
